import React from "react";
import doctorIcon from "../../assets/images/Svg/doctorIcon.svg";

/**
 * Single list row for a doctor, used both in the conversed list and the
 * "all consulted doctors" list. Takes a normalized doctor ({ userId, name,
 * imageName }) so it doesn't care which endpoint it came from.
 */
function DoctorListItem({ doctor, unreadCount, onClick }) {
  const avatarSrc = doctor.imageName
    ? process.env.REACT_APP_IMAGE_URL + doctor.imageName
    :doctor.raw.image? process.env.REACT_APP_IMAGE_URL + doctor.raw.image:  doctorIcon;

  return (
    <div
      className="flex items-center border-b p-2 hover:bg-gray-100 cursor-pointer"
      onClick={onClick}
    >
      <img
        src={avatarSrc}
        alt={doctor.name}
        className="w-12 h-12 rounded-full"
      />
      <div className="ml-4 flex-1">
        <div className="flex justify-between items-center">
          <h3 className="font-semibold flex items-center">{doctor.name}</h3>
          {unreadCount > 0 && (
            <div className="flex items-center justify-center">
              <span className="w-5 h-5 rounded-[50%] bg-dangerColor text-white text-center">
                {unreadCount}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(DoctorListItem);